import { Model } from './Model';

export class UpdateStatus extends Model {
  public apiPath = undefined;
  public className = 'updateStatus';
}